import { httpGet, httpPost, httpPatchMerge, httpDelete } from '../http'
import type { TEntityId } from '~/types/models'
import type { ILocationType } from '~/types/location/models'

const apiEntityPath = '/api/locationtypes'

export async function getLocationTypes() {
  const callingMn = getLocationTypes.name
  const apiPath = `${apiEntityPath}`
  return httpGet<ILocationType[]>({ callingMn, apiPath })
}

export async function createLocationType(entity: ILocationType) {
  const callingMn = createLocationType.name
  const apiPath = apiEntityPath
  return httpPost<ILocationType>({ callingMn, apiPath, entity })
}

export async function updateLocationType(
  entityData: Partial<ILocationType>,
  id: TEntityId
) {
  const callingMn = updateLocationType.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialLocationType = Partial<ILocationType>
  return httpPatchMerge<TPartialLocationType>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLocationType(entityData: ILocationType) {
  const callingMn = deleteLocationType.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
